<template>
  <WidgetCard title="Alerts by FQDN & tag" icon="cluster" :loading="loading" :error="error" :empty="emptyMessage">
    <template #headerExtra>
      <a-radio-group :value="days" @change="onChangeWindow">
        <a-radio-button :value="1">
          1D
        </a-radio-button>
        <a-radio-button :value="3">
          3D
        </a-radio-button>
        <a-radio-button :value="7">
          7D
        </a-radio-button>
      </a-radio-group>
    </template>
    <template v-if="ready">
      <div class="dw-split2">
        <div class="dw-split2__col">
          <div class="dw-split2__label">By FQDN</div>
          <div class="dw-rank">
            <div v-for="row in fqdns" :key="'f-' + row.name" class="dw-rank__row">
              <router-link
                class="dw-rank__name"
                :to="{ path: '/incident/list', query: { search: row.name } }"
                :title="row.name"
              >{{ row.name }}</router-link>
              <span class="dw-rank__count">
                <strong>{{ row.count.toLocaleString() }}</strong>
              </span>
              <span class="dw-rank__bar">
                <span class="dw-rank__fill" :style="{ width: barWidth(row.count, maxFqdn) }" />
              </span>
            </div>
            <div v-if="!fqdns.length" class="dw-split2__empty">
              No alerts in this period
            </div>
          </div>
        </div>
        <div class="dw-split2__col">
          <div class="dw-split2__label">By tag</div>
          <div class="dw-rank">
            <div v-for="row in tags" :key="'t-' + (row.id != null ? row.id : row.name)" class="dw-rank__row">
              <router-link
                v-if="canLinkTags && row.id != null"
                class="dw-rank__name"
                :to="{ path: '/incident/list', query: { tag: row.id } }"
                :title="row.name"
              >{{ row.name }}</router-link>
              <span v-else class="dw-rank__name" :title="row.name">{{ row.name }}</span>
              <span class="dw-rank__count">
                <strong>{{ row.count.toLocaleString() }}</strong>
              </span>
              <span class="dw-rank__bar">
                <span class="dw-rank__fill" :style="{ width: barWidth(row.count, maxTag) }" />
              </span>
            </div>
            <div v-if="!tags.length" class="dw-split2__empty">
              No tagged alerts
            </div>
          </div>
        </div>
      </div>
    </template>
  </WidgetCard>
</template>

<script>
  import WidgetCard from './WidgetCard.vue';
  import DashboardService from '../../services/dashboard.service';
  import dashboardWidget from '../../mixins/dashboardWidget.mixin';

  export default {
    name: 'AlertsByFqdnTagWidget',
    components: { WidgetCard },
    // Account-wide — deliberately not wired to the dashboard filters.
    mixins: [dashboardWidget],
    data() {
      return {
        days: 7,
        fqdns: [],
        tags: []
      };
    },
    computed: {
      // The alerts list only renders its tag filter under the same feature, so
      // without it a tag link would narrow the list with nothing to explain why.
      canLinkTags() {
        return this.$store.getters.hasFeature('tags');
      },
      ready() {
        return !this.loading && !this.error && (this.fqdns.length > 0 || this.tags.length > 0);
      },
      emptyMessage() {
        return !this.loading && !this.error && !this.fqdns.length && !this.tags.length
          ? 'No alerts in this period'
          : '';
      },
      maxFqdn() {
        return this.fqdns.reduce((m, r) => Math.max(m, r.count), 0) || 1;
      },
      maxTag() {
        return this.tags.reduce((m, r) => Math.max(m, r.count), 0) || 1;
      }
    },
    methods: {
      cacheDescriptors() {
        return [DashboardService.resources.fqdnTag(this.days)];
      },
      barWidth(count, max) {
        return `${((count || 0) / max) * 100}%`;
      },
      onChangeWindow(e) {
        this.days = e.target.value;
        this.fetchData();
      },
      fetchResource() {
        return DashboardService.fetchFqdnTagBreakdown(this.days);
      },
      applyResult(res) {
        this.fqdns = res.fqdns;
        this.tags = res.tags;
      }
    }
  };
</script>
